import { httpRequest } from "../../../utils/HttpRequest";
import {
    ItemDetailed,
    MaterialDetailed,
    IMaintenanceField,
    IMaintenanceRoSettleParams,
    IMaintenanceSearch,
    IMaintenanceDetail,
    IMaintenanceRoSettleAndWhConfirm,
    IMaintenanceList,
    IPrintExcel,
    IMaintenanceStatistics
} from "./maintenanceType"

class MaintenanceService {
    async page(searchVo: IMaintenanceSearch) {
        const apiUrl = "/zzw-vrm/maintenance/findPage";
        return await httpRequest.post<IMaintenanceList>(apiUrl, searchVo);
    }
    async total(searchVo: IMaintenanceSearch) {
        const apiUrl = "/zzw-vrm/maintenance/total";
        return await httpRequest.post<IMaintenanceStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/maintenance/findById/${id}`;
        return await httpRequest.get<IMaintenanceDetail>(apiUrl, { timeout: 60000 });
    }
    async insert(insertVo: IMaintenanceField) {
        const apiUrl = "/zzw-vrm/maintenance/insert";
        return await httpRequest.post<IMaintenanceDetail>(apiUrl, insertVo, { timeout: 300000 });
    }
    async update(updateVo: IMaintenanceField) {
        const apiUrl = "/zzw-vrm/maintenance/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo, { timeout: 300000 });
    }
    // 库房确认
    async warehousing(params: IMaintenanceRoSettleAndWhConfirm) {
        const apiUrl = "/zzw-vrm/maintenance/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修用料明细删除
    async materialDelete(params: MaterialDetailed) {
        const apiUrl = "/zzw-vrm/maintenance/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修项目明细删除
    async itemDelete(params: ItemDetailed) {
        const apiUrl = "/zzw-vrm/maintenance/itemDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IMaintenanceRoSettleParams) {
        const apiUrl = "/zzw-vrm/maintenance/settlePro";
        // const apiUrl = "/zzw-vrm/maintenance/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/zzw-vrm/maintenance/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/zzw-vrm/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/zzw-vrm/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //预约转维修
    async transfer(params: object) {
        const apiUrl = "/zzw-vrm/maintenance/transfer";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //转车间
    async tran(params: object) {
        const apiUrl = "/zzw-vrm/maintenance/tran";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IMaintenanceSearch) {
        const apiUrl = "/zzw-vrm/maintenance/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //详情导出
    async detailsExport(params: IMaintenanceSearch) {
        const apiUrl = "/zzw-vrm/maintenance/repairFormExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印Excel格式
    async excelPrint(params: IPrintExcel) {
        const apiUrl = "/zzw-vrm/maintenance/exportFind";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印预约单Excel格式
    async appointmentExcelPrint(params: IPrintExcel) {
        const apiUrl = "/zzw-vrm/appointment/exportFind";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/maintenance/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
    //审核接口
    async examine(params: object) {
        const apiUrl = `/zzw-vrm/maintenance/examine`;
        return await httpRequest.post(apiUrl, params);
    }
    //审核通过接口
    async approved(params: object) {
        const apiUrl = `/zzw-vrm/maintenance/approved`;
        return await httpRequest.post(apiUrl, params);
    }
    //维修退单审核通过
    async chargebackPassed(params: object) {
        const apiUrl = `/zzw-vrm/maintenance/chargebackPassed`;
        return await httpRequest.post(apiUrl, params);
    }
    //维修退单待审核
    async chargebackApproval(params: object) {
        const apiUrl = `/zzw-vrm/maintenance/chargebackApproval`;
        return await httpRequest.post(apiUrl, params);
    }
}
export const maintenanceService = new MaintenanceService();
